import React, { useEffect } from "react";
import "./Services.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Service = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section
        className="service-hero-section"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/images/hero1.jpg"})`,
        }}
      >
        <div className="overlay"></div>
        <div className="service-hero-content" data-aos="fade-up">
          <h1>Our Services</h1>
          <p>Explore the wide range of services we offer</p>
        </div>
      </section>

      {/* Our Services Section (copied from Home page) */}
      <section className="services-section">
        <div className="services-left">
          <img
            src={process.env.PUBLIC_URL + "/images/Service.png"}
            alt="Web Development Service"
          />
        </div>

        <div className="services-right">
          <h5>OUR SERVICES</h5>
          <h2>We Provide High-Quality Solutions</h2>
          <p>
            We “RIKSONS INSPECTION SERVICES” are committed to inspecting products carefully, fulfilling customer requirements at competitive cost. We believe in continual improvement of our performance in respective areas and operation by complying requirements of quality management system, improving employee skills and team work aimed at achieving higher customer satisfaction. Customer first is one of the core strategies of our company. We give top priorities for understanding the customer needs and train the team for comprehensive solutions to meet our mission.
          </p>

          {/* Optional points */}
          {/* <div className="services-points">
            <div className="service-point">Web Development</div>
            <div className="service-point">Mobile Applications</div>
            <div className="service-point">Digital Marketing</div>
            <div className="service-point">UI/UX Design</div>
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default Service;
